// Mock data per l'app di posta elettronica (demo)

export const FOLDERS = [
  { id: "ricevute", label: "RICEVUTE" },
  { id: "inviate", label: "INVIATE" },
  { id: "uscita", label: "IN USCITA" },
  { id: "bozze", label: "BOZZE" },
  { id: "eliminate", label: "ELIMINATE" },
  { id: "rifiutate", label: "RIFIUTATE" },
];

// Nessun account demo: gli account vengono aggiunti dall'utente
export const PEC_ACCOUNTS = [];

export const ACCOUNTS = [{ id: "tutti", label: "TUTTI" }];

// Colore identificativo di ogni account (cerchio email)
export const ACCOUNT_COLORS = {
  account2: "#f6ba00", // giallo
  account3: "#2fa64f", // verde
  account4: "#8e44ad", // viola
  account5: "#e0559a", // rosa
  pec1: "#1a6fd4", // blu
  pec2: "#0f9d9d", // verde acqua
  pec3: "#5b5bd6", // indaco
  social: "#10141a", // nero
};

const SOCIAL_COLORS = {
  Facebook: "#1877f2",
  Instagram: "#d6339a",
  LinkedIn: "#0a66c2",
  TikTok: "#10141a",
  X: "#111111",
  YouTube: "#ff0000",
  Pinterest: "#e60023",
  Snapchat: "#e6c700",
  Threads: "#333333",
  WhatsApp: "#25d366",
  Telegram: "#229ed9",
};

// Parole chiave (dominio mittente o nome) → rete social
const SOCIAL_KEYWORDS = [
  ["Instagram", ["instagram"]],
  ["Facebook", ["facebook", "facebookmail", "fb.com", "meta.com", "metamail"]],
  ["Threads", ["threads.net", "threads"]],
  ["LinkedIn", ["linkedin"]],
  ["TikTok", ["tiktok"]],
  ["X", ["twitter"]],
  ["YouTube", ["youtube"]],
  ["Pinterest", ["pinterest"]],
  ["Snapchat", ["snapchat"]],
  ["WhatsApp", ["whatsapp"]],
  ["Telegram", ["telegram"]],
];

// Riconosce il social dal dominio dell'indirizzo mittente
// es: no-reply@mail.instagram.com -> Instagram
export function socialNetwork(e) {
  if (e.categoria === "pec" || e.pec_tipo) return null;
  const addr = (e.email || "").toLowerCase();
  const domain = addr.split("@")[1] || "";
  const name = (e.mittente || "").toLowerCase();
  const subj = " " + (e.oggetto || "").toLowerCase() + " ";
  for (const [rete, keys] of SOCIAL_KEYWORDS) {
    if (keys.some((k) => domain.includes(k) || (k.length > 4 && name.includes(k)))) return rete;
  }
  // Nome della rete nel titolo (es. "Nuove notifiche da Facebook", "Il tuo video TikTok")
  for (const [rete, keys] of SOCIAL_KEYWORDS) {
    if (rete === "X") continue;
    if (keys.some((k) => k.length > 4 && !k.includes(".") && subj.includes(k))) return rete;
  }
  // Uccellino (Twitter): solo email che contengono la parola "twitter"
  if (/\btwitter\b/.test(subj)) return "X";
  return null;
}

export function emailColor(email) {
  const s = socialNetwork(email);
  if (s && SOCIAL_COLORS[s]) return SOCIAL_COLORS[s];
  if (email.colore) return email.colore;
  return ACCOUNT_COLORS[email.account] || "#f6ba00";
}

// Nessun dato demo: in produzione le email arrivano solo dagli account collegati
export const MOCK_EMAILS = [];
